import { useMatches } from 'react-router-dom';
import { RouteMatchShape } from '@/core/routes/routes.types';

export default function useRouteHandle(option: keyof RouteMatchShape['handle']) {
  const matches = useMatches() as RouteMatchShape[];

  const handleValue = matches
    .filter((match) => Boolean(match.handle?.[option]))
    .map((match) => match.handle?.[option])
    .pop();

  return handleValue;
}
